import type React from "react";
import "./SocialMedia.css";

interface SocialMediaLink {
  href: string;
  icon: React.ReactNode;
  title: string;
}

const GradientDefs = () => (
  <defs>
    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#FF7E4B" />
      <stop offset="100%" stopColor="#FF518C" />
    </linearGradient>
    <linearGradient id="gradient1-hover" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#66319B" />
      <stop offset="100%" stopColor="#FF518C" />
    </linearGradient>
    <clipPath id="clip0_45_4051">
      <rect width="24.2188" height="24.2188" fill="white" transform="translate(0.21875)" />
    </clipPath>
  </defs>
);

const OSEGradientDefs = () => (
  <defs>
    <linearGradient id="ose-gradient" x1="0" y1="0" x2="25" y2="25" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stopColor="#66319B" />
      <stop offset="100%" stopColor="#FF518C" />
    </linearGradient>
  </defs>
);

// Social media data
const socialMediaLinks: SocialMediaLink[] = [
  // {
  //   href: "https://mastodon.social/@OS_Economy",
  //   title: "Open Source Economy on Mastodon",
  //   icon: (
  //     <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="mastodonTitle" className="group">
  //       <title id="mastodonTitle">Mastodon</title>
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M17.4239 19.0345C20.553 18.6608 23.2775 16.7329 23.6199 14.9712C24.1594 12.1962 24.1149 8.19913 24.1149 8.19913C24.1149 2.78166 20.5655 1.19372 20.5655 1.19372C18.7759 0.371758 15.7028 0.0261025 12.5101 0H12.4316C9.23893 0.0261025 6.16785 0.371758 4.37808 1.19372C4.37808 1.19372 0.82855 2.78166 0.82855 8.19913C0.82855 8.52756 0.826853 8.873 0.825086 9.23261C0.820178 10.2313 0.814733 11.3394 0.84362 12.4959C0.972518 17.7939 1.81493 23.0154 6.71331 24.3119C8.97185 24.9097 10.911 25.0348 12.4727 24.949C15.3048 24.792 16.8946 23.9382 16.8946 23.9382L16.8012 21.8834C16.8012 21.8834 14.7774 22.5216 12.5044 22.4438C10.2525 22.3666 7.87514 22.2009 7.51092 19.4361C7.47728 19.1932 7.46046 18.9336 7.46046 18.6608C7.46046 18.6608 9.6711 19.2012 12.4727 19.3295C14.1857 19.4081 15.7923 19.2292 17.4239 19.0345ZM19.9282 15.1789V8.61921C19.9282 7.27857 19.5868 6.21321 18.9013 5.42502C18.1941 4.63684 17.2681 4.23279 16.1188 4.23279C14.7888 4.23279 13.7817 4.74394 13.116 5.76637L12.4685 6.85151L11.8212 5.76637C11.1553 4.74394 10.1482 4.23279 8.81834 4.23279C7.66889 4.23279 6.74292 4.63684 6.03587 5.42502C5.35021 6.21321 5.00886 7.27857 5.00886 8.61921V15.1789H7.60767V8.81202C7.60767 7.4699 8.17237 6.78868 9.3019 6.78868C10.5508 6.78868 11.1768 7.59678 11.1768 9.19468V12.6796H13.7603V9.19468C13.7603 7.59678 14.3862 6.78868 15.6351 6.78868C16.7646 6.78868 17.3294 7.4699 17.3294 8.81202V15.1789H19.9282Z"
  //         fill="white"
  //         className="group-hover:fill-[url(#ose-gradient)]"
  //       />
  //       <OSEGradientDefs />
  //     </svg>
  //   ),
  // },

  // {
  //   href: "https://x.com/OS_Economy",
  //   title: "Open Source Economy on X",
  //   icon: (
  //     <svg className="svgicon-2" width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="xTitle">
  //       <title id="xTitle">X (formerly Twitter)</title>
  //       <GradientDefs />
  //       <g clipPath="url(#clip0_45_4051)">
  //         <path
  //           d="M13.1067 11.6959L18.5568 19.4915H16.3201L11.8727 13.1303V13.1299L11.2198 12.1961L6.02448 4.76465H8.26121L12.4538 10.7621L13.1067 11.6959Z"
  //           fill="white"
  //         />
  //         <path
  //           d="M21.7894 0H2.80439C1.35916 0 0.1875 1.17166 0.1875 2.61689V21.6019C0.1875 23.0471 1.35916 24.2188 2.80439 24.2188H21.7894C23.2346 24.2188 24.4062 23.0471 24.4062 21.6019V2.61689C24.4062 1.17166 23.2346 0 21.7894 0ZM15.635 20.538L11.1345 13.9881L5.49983 20.538H4.04355L10.4879 13.0473L4.04355 3.66834H8.95875L13.2204 9.87067L18.556 3.66834H20.0123L13.8672 10.8116H13.8668L20.5502 20.538H15.635Z"
  //           fill="#fff"
  //         />
  //       </g>
  //     </svg>
  //   ),
  // },
  {
    href: "https://github.com/Open-Source-Economy",
    title: "Open Source Economy on GitHub",
    icon: (
      <svg width="30" height="30" className="svgicon-2" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="githubTitle">
        <title id="githubTitle">GitHub</title>
        <g clipPath="url(#clip0_45_4051)">
          <path
            d="M21.5909 0H3.40909C2.50494 0 1.63783 0.359171 0.9985 0.9985C0.359171 1.63783 0 2.50494 0 3.40909V21.5909C0 22.4951 0.359171 23.3622 0.9985 24.0015C1.63783 24.6408 2.50494 25 3.40909 25H21.5909C22.4951 25 23.3622 24.6408 24.0015 24.0015C24.6408 23.3622 25 22.4951 25 21.5909V3.40909C25 2.50494 24.6408 1.63783 24.0015 0.9985C23.3622 0.359171 22.4951 0 21.5909 0ZM14.9503 19.9645C14.5497 20.0412 14.4134 19.7997 14.4134 19.5994C14.4134 19.3494 14.4233 18.5241 14.4233 17.4972C14.4233 16.777 14.169 16.3068 13.8963 16.0767C15.6335 15.8878 17.4602 15.2386 17.4602 12.2898C17.4718 11.5242 17.1844 10.7843 16.6591 10.2273C16.7372 10.0327 17.0014 9.25142 16.581 8.1946C16.581 8.1946 15.9276 7.98864 14.4503 8.98153C13.171 8.63684 11.8233 8.63684 10.544 8.98153C9.04972 7.98722 8.39489 8.1946 8.39489 8.1946C7.96875 9.25426 8.23864 10.0355 8.3196 10.2273C7.79308 10.7826 7.50455 11.5218 7.51562 12.2869C7.51562 15.2273 9.33949 15.8878 11.0668 16.0795C10.7835 16.351 10.6079 16.7158 10.5724 17.1065C10.125 17.3026 8.9929 17.642 8.29972 16.4688C8.29972 16.4688 7.88778 15.7301 7.10369 15.6776C7.10369 15.6776 6.34091 15.6676 7.0483 16.1435C7.0483 16.1435 7.5625 16.3807 7.91761 17.2656C7.91761 17.2656 8.37642 18.7585 10.5497 18.2969C10.5497 18.9361 10.5582 19.419 10.5582 19.6023C10.5582 19.7855 10.4162 20.0426 10.0256 19.9702C6.92614 18.9588 4.6875 16.0824 4.6875 12.6903C4.6875 8.45028 8.18324 5.01989 12.5 5.01989C16.8168 5.01989 20.3125 8.45739 20.3125 12.6974C20.3125 16.0767 18.0767 18.956 14.9503 19.9645Z"
            fill="white"
          />
        </g>
      </svg>
    ),
  },
  {
    href: "https://www.linkedin.com/company/open-source-economy/",
    title: "Open Source Economy on LinkedIn",
    icon: (
      <svg width="30" className="svgicon-2" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="linkedinTitle">
        <title id="linkedinTitle">LinkedIn</title>
        <g clipPath="url(#clip0_45_4051)">
          <path
            d="M22.0156 0H2.64062C1.30859 0 0.21875 1.08984 0.21875 2.42188V21.7969C0.21875 23.1289 1.30859 24.2188 2.64062 24.2188H22.0156C23.3477 24.2188 24.4375 23.1289 24.4375 21.7969V2.42188C24.4375 1.08984 23.3477 0 22.0156 0ZM7.48438 20.5859H3.85156V9.6875H7.48438V20.5859ZM5.66797 7.62891C4.45703 7.62891 3.48828 6.66016 3.48828 5.44922C3.48828 4.23828 4.45703 3.26953 5.66797 3.26953C6.87891 3.26953 7.84766 4.23828 7.84766 5.44922C7.84766 6.66016 6.87891 7.62891 5.66797 7.62891ZM20.8047 20.5859H17.1719V14.168C17.1719 13.1993 16.3242 12.3516 15.3555 12.3516C14.3867 12.3516 13.5391 13.1993 13.5391 14.168V20.5859H9.90625V9.6875H13.5391V11.1406C14.1445 10.1719 15.4766 9.44531 16.5664 9.44531C18.8672 9.44531 20.8047 11.3828 20.8047 13.6836V20.5859Z"
            fill="white"
          />
        </g>
      </svg>
    ),
  },
  // {
  //   href: "https://discord.com/invite/YX88NaYgrP",
  //   title: "Open Source Economy on Discord",
  //   icon: (
  //     <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="svgicon-2">
  //       <title id="discordTitle">Discord</title>
  //       <GradientDefs />
  //       <g clipPath="url(#clip0_45_4051)">
  //         <path
  //           d="M3.72913 22.0792H18.5823L17.8729 19.7823L19.5698 21.2385L21.125 22.6323L23.9583 25V2.57812C23.8875 1.18437 22.6875 0 21.2 0L3.73433 0.003125C2.24788 0.003125 1.04163 1.18958 1.04163 2.58333V19.5C1.04163 20.9698 2.24579 22.0792 3.72913 22.0792ZM14.7166 5.91979L14.6823 5.93229L14.6948 5.91979H14.7166ZM6.76767 7.24167C8.67704 5.85208 10.4468 5.91875 10.4468 5.91875L10.5895 6.05938C8.25308 6.61667 7.19371 7.66042 7.19371 7.66042C7.19371 7.66042 7.47704 7.52188 7.97183 7.31042C11.1187 6.07292 14.5552 6.1625 17.7364 7.72917C17.7364 7.72917 16.675 6.75312 14.4823 6.12812L14.676 5.9375C14.9791 5.93854 16.5833 5.99479 18.3 7.25C18.3 7.25 20.2208 10.5312 20.2208 14.5625C20.1573 14.4854 19.0291 16.2979 16.126 16.3604C16.126 16.3604 15.6343 15.8042 15.2843 15.3188C16.9823 14.8313 17.6177 13.8563 17.6177 13.8563C17.0604 14.2073 16.552 14.4156 16.1395 14.624C15.5052 14.9031 14.8698 15.0406 14.2354 15.1813C11.2312 15.6688 9.54475 14.8531 7.951 14.2063L7.40621 13.9292C7.40621 13.9292 8.04058 14.9042 9.67079 15.3917C9.24267 15.8802 8.81871 16.4354 8.81871 16.4354C5.91663 16.3667 4.85829 14.5542 4.85829 14.5542C4.85829 10.5167 6.76767 7.24167 6.76767 7.24167Z"
  //           fill="white"
  //         />
  //         <path
  //           d="M14.9042 13.306C15.6448 13.306 16.2479 12.681 16.2479 11.9102C16.2479 11.1445 15.6479 10.5195 14.9042 10.5195V10.5227C14.1667 10.5227 13.5625 11.1456 13.5604 11.9164C13.5604 12.681 14.1635 13.306 14.9042 13.306Z"
  //           fill="white"
  //         />
  //         <path
  //           d="M10.0938 13.306C10.8344 13.306 11.4375 12.681 11.4375 11.9102C11.4375 11.1445 10.8385 10.5195 10.0979 10.5195L10.0938 10.5227C9.35312 10.5227 8.75 11.1456 8.75 11.9164C8.75 12.681 9.35312 13.306 10.0938 13.306Z"
  //           fill="white"
  //         />
  //       </g>
  //     </svg>
  //   ),
  // },
  {
    href: "https://www.youtube.com/@OpenSourceEconomy-hn3tg",
    title: "Open Source Economy on YouTube",
    icon: (
      <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="group">
        <title id="youtubeTitle">YouTube</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 0H22.5C23.875 0 25 1.125 25 2.5V22.5C25 23.875 23.875 25 22.5 25H2.5C1.125 25 0 23.875 0 22.5V2.5C0 1.125 1.125 0 2.5 0ZM20.5656 9.84444C20.5156 9.17778 20.4406 8.65278 20.3323 8.26111C20.1239 7.51111 19.6406 7.02778 18.8906 6.81944C18.0323 6.58611 15.8573 6.45278 12.3656 6.45278L11.0406 6.50278C10.1239 6.50278 9.13226 6.52778 8.04893 6.58611C6.94893 6.63611 6.23226 6.71111 5.8406 6.81944C5.0906 7.02778 4.60726 7.51111 4.39893 8.26111C4.1656 9.11944 4.03226 10.4611 4.03226 12.2861L4.08226 12.9861C4.08226 13.4861 4.10726 14.0611 4.1656 14.7278C4.2156 15.3944 4.2906 15.9194 4.39893 16.3111C4.60726 17.0611 5.0906 17.5444 5.8406 17.7528C6.69893 17.9861 8.87393 18.1194 12.3656 18.1194L13.6906 18.0694C14.6073 18.0694 15.5989 18.0444 16.6823 17.9861C17.7823 17.9361 18.4989 17.8611 18.8906 17.7528C19.6406 17.5444 20.1239 17.0611 20.3323 16.3111C20.5656 15.4528 20.6989 14.1111 20.6989 12.2861L20.6489 11.5861C20.6489 11.0861 20.6239 10.5111 20.5656 9.84444ZM10.6989 14.7861L15.0239 12.2861L10.6989 9.78611V14.7861Z"
          fill="white"
          className="group-hover:fill-[url(#ose-gradient)]"
        />
        <OSEGradientDefs />
      </svg>
    ),
  },
];

export function SocialMedia() {
  return (
    <>
      {socialMediaLinks.map((link, index) => (
        <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" title={link.title}>
          {link.icon}
        </a>
      ))}
    </>
  );
}
